import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDeliveryNotificationSetting implements BaseEnumType {
  private static allValues: EnumDeliveryNotificationSetting[] = []; // make sure this is top-most
  
  public static unknown = new EnumDeliveryNotificationSetting(0, "Unknown", "enum_delivery_notification_setting_unknown");
  public static off = new EnumDeliveryNotificationSetting(1, "Off", "enum_delivery_notification_setting_off");
  public static toDeliveryRecipient = new EnumDeliveryNotificationSetting(2, "ToDeliveryRecipient", "enum_delivery_notification_setting_to_delivery_recipient");
  public static toSpecifiedAddress = new EnumDeliveryNotificationSetting(3, "ToSpecifiedAddress", "enum_delivery_notification_setting_to_specified_address");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDeliveryNotificationSetting.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumDeliveryNotificationSetting.unknown; }
  public isOff() { return this === EnumDeliveryNotificationSetting.off; }
  public isToDeliveryRecipient() { return this === EnumDeliveryNotificationSetting.toDeliveryRecipient; }
  public isToSpecifiedAddress() { return this === EnumDeliveryNotificationSetting.toSpecifiedAddress; }

  public static getValues(): readonly EnumDeliveryNotificationSetting[] {
    return EnumDeliveryNotificationSetting.allValues;
  }

  public static getValuesExcept0(): readonly EnumDeliveryNotificationSetting[] {
    return EnumDeliveryNotificationSetting.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDeliveryNotificationSetting {
    const found = EnumDeliveryNotificationSetting.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDeliveryNotificationSetting - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDeliveryNotificationSetting): EnumDeliveryNotificationSetting {
    const found = name ? EnumDeliveryNotificationSetting.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDeliveryNotificationSetting - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDeliveryNotificationSetting>): boolean {
    return this.key === other?.key;
  }
}